<template>
  <div class="supplier-box mini-width">
    <div class="w-1400">
      <div class="supplier-box-title">
        <title-home title="优质供应商" English="Quality Supplier"></title-home>
      </div>
      <el-carousel height="280px" direction="vertical" :autoplay="false">
        <el-carousel-item v-for="(item,index) in supplierGroups" :key="index">
          <div class="logo-show">
            <div class="logo-show-item" v-for="i in item" :key="i.id">
              <img :src="i.image" alt=""/>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>

    </div>
  </div>

</template>
<script>
import TitleHome from "@/components/Title/title-home.vue";
import {getGoodSupplierList} from "@/api/modules/home";

export default {
  name: "supplier",
  components: {TitleHome},
  data() {
    return {
      supplierList: [],
      supplierGroups: [] // 用于存储分组后的数据
    }
  },
  mounted() {
    // 获取优质供应商（使用缓存，缓存1小时）
    this.getSupplier();
  },
  methods: {
    // 获取优质供应商
    async getSupplier() {

      let res = await getGoodSupplierList({page: 1, limit: 1000});
      this.supplierList = res.data.data.data;
      // 调用分组方法
      this.supplierGroups = this.groupSupplierData(this.supplierList, 12);
    },
    // 将数组分组
    groupSupplierData(arr, size) {
      const chunks = [];
      for (let i = 0; i < arr.length; i += size) {
        chunks.push(arr.slice(i, i + size));
      }
      return chunks;
    }
  }
}
</script>

<style scoped lang="scss">

.supplier-box {
  // height: 655px;
  background: #e4ecfc;
  padding: 40px 0;
  box-sizing: border-box;
  min-height: 510px;

  .supplier-box-title {
    text-align: center;
    margin-bottom: 29px;
  }

  .logo-show {
    display: flex;
    flex-wrap: wrap;
    gap: 40px;
    justify-content: space-between;
    margin: 0 20px;


    .logo-show-item {
      width: 200px;
      height: 100px;
      background: #ffffff;
      text-align: center;
      padding-top: 10px;
      border-radius: 15px;
      box-sizing: border-box;

      &:last-child {
        margin-right: auto;
      }

      &:hover {
        box-shadow: 0px 0px 10px 10px rgba(0, 0, 0, 0.1);
        transform: scale(1.05);
        transition: all 0.3s ease;
      }

      img {
        width: 80%;
        height: 80%;
        object-fit: contain;
      }
    }
  }
}


</style>
